// import invite from '../components/invite.vue'
const appMeeting = () =>
    import ('@/layout/AppMeeting.vue')
const caseSpace = () =>
    import ('@/views/caseSpace/index.vue')
export default {
    path: '/',
    component: appMeeting,
    sort: 2,
    meta: {
        title: '案件空间',
        //requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
    },
    children: [{
            path: '/caseSpace', // 调解员入口
            name: 'caseSpace',
            component: caseSpace
        },
    ]
}